import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "cahd_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Public
export const fetchProducts = (params) => api.get("/products", { params }).then((r) => r.data);
export const fetchProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const fetchSettings = () => api.get("/settings").then((r) => r.data);
export const getDeliveryQuote = (orderValue, distanceMiles) =>
  api.post("/delivery/quote", { orderValue, distanceMiles }).then((r) => r.data);
export const createOrder = (payload) => api.post("/orders", payload).then((r) => r.data);
export const createCheckout = (order_id, origin_url) =>
  api.post("/payments/checkout", { order_id, origin_url }).then((r) => r.data);
export const getPaymentStatus = (sid) => api.get(`/payments/status/${sid}`).then((r) => r.data);

// Admin
export const adminLogin = (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = () => api.get("/auth/me").then((r) => r.data);
export const adminProducts = () => api.get("/admin/products").then((r) => r.data);
export const adminCreateProduct = (d) => api.post("/admin/products", d).then((r) => r.data);
export const adminUpdateProduct = (id, d) => api.put(`/admin/products/${id}`, d).then((r) => r.data);
export const adminDeleteProduct = (id, hard = false) => api.delete(`/admin/products/${id}?hard=${hard}`).then((r) => r.data);
export const adminBulkUpdate = (ids, updates) => api.post("/admin/products/bulk-update", { ids, updates }).then((r) => r.data);
export const adminUpload = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const adminOrders = () => api.get("/admin/orders").then((r) => r.data);
export const adminUpdateOrderStatus = (id, status) => api.put(`/admin/orders/${id}/status`, { status }).then((r) => r.data);
export const adminGetSettings = () => api.get("/admin/settings").then((r) => r.data);
export const adminUpdateSettings = (d) => api.put("/admin/settings", d).then((r) => r.data);
